module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGf962ecd4aa65992b5f5c7d4078ad5b7b.f962ecd4.png";